export default __webpack_public_path__ + "static/inner-belief_big-image-1-6750b27774b27a56c115805cd49768f7.webp";